import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/lib/brand";

export default function BookCTA({
  title = "Ready to clear it out?",
  body = "Answer five short steps — address, items, room photos, preferred date and your details — and we'll take it from there.",
  className = "",
}) {
  return (
    <section className={`pb-16 ${className}`} data-testid="section-cta">
      <div className="max-w-6xl mx-auto px-6 sm:px-10">
        <div className="relative overflow-hidden rounded-3xl bg-[#0F172A] p-8 sm:p-14">
          <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#FF7F00]/30 blur-3xl" />
          <div className="relative grid sm:grid-cols-2 gap-6 items-center">
            <div>
              <h3 className="font-display text-2xl sm:text-3xl font-extrabold text-white leading-tight tracking-tight">
                {title}
              </h3>
              <p className="mt-3 text-slate-300 max-w-md">{body}</p>
            </div>
            <div className="flex sm:justify-end gap-3 flex-wrap">
              <Link
                to="/book"
                data-testid="cta-book"
                className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-[#FF7F00] hover:bg-[#E67000] text-white font-bold shadow-md shadow-orange-500/20 transition-colors"
              >
                Get a Free Quote <ArrowRight className="h-4 w-4" />
              </Link>
              <a
                href={`tel:${COMPANY.phoneTel}`}
                data-testid="cta-phone"
                className="inline-flex items-center gap-2 h-12 px-5 rounded-full border border-white/20 text-white hover:bg-white/5 font-semibold"
              >
                <Phone className="h-4 w-4" /> Call {COMPANY.phoneDisplay}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
